module.exports = __webpack_public_path__ + "media/images/products/retailers-newsletter-2-blackwells-975beec99ab6d775277aaa90c2612513.jpg";